export const paymentGatewayRouteDef = [
    {
        path: 'payement_status',
        component: 'HdfcPaymentStatusComponent',
        data: {
            selector: 'kx-hdfc-payment-status',
            resource: 'epayment_transaction_details',
        }
    },
]